import React, { useEffect, useState, useRef, useCallback } from 'react';
import { View, Text, StyleSheet, TextInput, Pressable } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import { laborValues, equipmentValues } from '../store/faceValues';
import { updateUserDataArray as _updateUserDataArray, loadUserData as _loadUserData, f, fNum, pNum, sum, cN, effectiveIsProjectCoordinator, effectiveIsBuyer } from '../db/company';
import { selectedJobAtom, jobUserDataAtom, jobCostDetailAtom, selectedJobDataAtom, startDateActualAtom, selectedVersionAtom, projectCompleteAtom, dataSourceVersionAtom, isLiveVersionAtom, selectedVersionLockedAtom, equipmentRatesAtom, equipmentDescriptionsAtom, userIdAtom, userEmailCheckAtom, userRoleAtom, previewRoleAtom } from '../store/company';
import { useApiTracker } from '../store/useApiStatus';
import moment from 'moment';
import EquipmentDashboard from './burnToolPhasedEquipmentDashboard';
import AuditHistoryPanel from './auditHistoryPanel';

const BurnToolEquipment = (props) => {
    const trackApi = useApiTracker('burnToolEquipment');
    const updateUserDataArray = (data) => trackApi('updateUserDataArray', 'save', () => _updateUserDataArray(data)).catch(() => {});
    const loadUserData = (params) => trackApi('loadUserData', 'load', () => _loadUserData(params));
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [selectedJobData, setSelectedJobData] = useAtom(selectedJobDataAtom);
    const [versions, setVersions] = useAtom(dataSourceVersionAtom);
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom)
    const [startDateActual, setStartDateActual] = useAtom(startDateActualAtom);
    const [versionInfo, setVersionInfo] = useState({});
    const width = window.innerWidth;
    const [labor, setLabor] = useAtom(laborValues);
    const [equipment, setEquipment] = useAtom(equipmentValues);
    const [historicalWeeks, setHistoricalWeeks] = useState([])
    const [estimatedWeeks, setEstimatedWeeks] = useState([])
    const [truckPay, setTruckPay] = useState([])
    const [rigRent, setRigRent] = useState([])
    const [equipmentBurn, setEquipmentBurn] = useState([])
    const [actualLaborCost, setActualLaborCost] = useState(0)
    const [actualLaborHours, setActualLaborHours] = useState(0)
    const [forecastLaborHours, setForecastLaborHours] = useState(0)
    const [forecastLaborCost, setForecastLaborCost] = useState(0)
    const [totalCOHours, setTotalCOHours] = useState(0)
    const [totalCOCost, setTotalCOCost] = useState(0)
    const [totalDayZero, setTotalDayZero] = useState(0)
    const [totalDayZeroHours, setTotalDayZeroHours] = useState(0)
    const [currentBudget, setCurrentBudget] = useState('-')
    const [currentBudgetHours, setCurrentBudgetHours] = useState('-')
    const [totalCost, setTotalCost] = useState(0)
    const [totalHours, setTotalHours] = useState(0)
    const [overUnder, setOverUnder] = useState(0)
    const [overUnderHours, setOverUnderHours] = useState(0)
    const [percentComplete, setPercentComplete] = useState(0)
    const [percentCompleteHours, setPercentCompleteHours] = useState(0)
    const [totalActualHours, setTotalActualHours] = useState(0)
    const [totalActualCost, setTotalActualCost] = useState(0)
    const [totalEstCost, setTotalEstCost] = useState(0)
    const [totalEstHours, setTotalEstHours] = useState(0)
    const [totalBurnPerHour, setTotalBurnPerHour] = useState(0)
    const [totalHourPerWeek, setTotalHourPerWeek] = useState(0)

    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [jobCostDetail, setJobCostDetail] = useAtom(jobCostDetailAtom);
    const [completionDateForecast, setCompletionDateForecast] = useAtom(projectCompleteAtom);
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [equipmentRates] = useAtom(equipmentRatesAtom);
    const [equipmentDescriptions] = useAtom(equipmentDescriptionsAtom);
    const [userId] = useAtom(userIdAtom);
    const [userEmailCheck] = useAtom(userEmailCheckAtom);
    const canSeeWipTabs = true;
    const [userRole] = useAtom(userRoleAtom);
    const [previewRole] = useAtom(previewRoleAtom);
    // Project Coordinators only get the Equipment Dashboard subtab — the forecast
    // grid never renders for them (see pcAllowedTabs in db/company.js).
    // Derived (not initial state) so it holds even when the role loads late.
    const isPC = effectiveIsProjectCoordinator(previewRole, userRole, userEmailCheck) || effectiveIsBuyer(previewRole, userRole, userEmailCheck);
    const [subTab, setSubTab] = useState('grid'); // 'grid' | 'dashboard'
    const activeSubTab = isPC ? 'dashboard' : subTab;
    const [showRatesPopup, setShowRatesPopup] = useState(false);
    const [ratesSearch, setRatesSearch] = useState('');
    const [textTimeout, setTextTimeout] = useState(null)
    const localChanges = useRef([])
    const focusedId = useRef(null)

    const s = StyleSheet.create({
        topContainer: {
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: 5
        },
        container: {
            flexDirection: 'row',
            paddingBottom: 0,
            borderBottomWidth: 1,
            borderColor: '#F9F8FB'
        },
        smallContainer: {

        },
        span2: {
            width: 150,
            alignItems: 'center',
            fontSize: 14,
            padding: 1

        },
        span: {
            width: 75,
            alignItems: 'center',
            fontSize: 14,
            padding: 1,
            textAlign: 'right'


        },
        span3: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 3
        },
        span2T: {
            width: 125,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            border: '1px solid #e0e0e0',
            borderRight: '2px solid #e0e0e0'
        },
        spanHT: {
            width: 40,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right'
        },
        spanT: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
            border: '1px solid #e0e0e0',
            borderRight: '2px solid #e0e0e0'
        },
        spanTH: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
            backgroundColor: 'lightyellow'
        },
        span3T: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 3
        },
        spanH: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanWeek: {
            width: 100,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
            border: '1px solid #e0e0e0',
            borderRight: '2px solid #e0e0e0',
        },
        spanWeekH: {
            width: 100,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanWeekTotals: {
            width: 100,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        span2H: {
            width: 125,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanHH: {
            width: 40,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            textAlign: 'right',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        span3H: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanTotals: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        span2Totals: {
            width: 125,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        spanHTotals: {
            width: 40,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            textAlign: 'right',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        span3Totals: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        sectionTitle: {
            fontSize: 18,
            paddingVertical: 10,
            paddingHorizontal: 4,
            fontWeight: '700',
            color: '#1e293b',
            letterSpacing: 0.3,
        },
        card: {
            width: 300,
            //boxShadow: "10px 10px 17px -12px rgba(0,0,0,0.75)",
            borderRadius: 5,
            padding: 8,
            borderWidth: .5,
            borderColor: 'lightgrey',
        },
        tInput: {
            borderWidth: .5,
            borderColor: 'grey',
            borderWidthLeft: 4,
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
        },
        tInputL: {
            borderWidth: .5,
            borderColor: 'grey',
            borderWidthLeft: 4,
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
        }

    })

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
    }, [versions]);

    useEffect(() => {
        if (selectedJob && selectedVersion) {
            loadUserData({ id: selectedJob, forecastGuid: selectedVersion, live: isLiveVersion }).then((data) => {
                setJobUserData(data?.data);
            })
        }
    }, [selectedJob, selectedVersion])

    useEffect(() => {
        calculateTotals()
    }, [jobCostDetail, jobUserData, completionDateForecast])

    const calculateTotals = () => {
        if (!jobUserData || !jobUserData.length) {
            return
        }
        //console.log('calculating totals')

        const uData = {}
        const bData = {}
        const coData = {}
        let dayZeroTotal = 0
        let dayZeroHoursTotal = 0
        let totalCOCost = 0
        let totalCOHours = 0

        jobUserData.forEach((d) => {
            if (d?.Forecast_Tab === 'Burn Tool Equipment') {
                uData[d?.Forecast_Row_ID] = {
                    id: d?.Forecast_Row_ID,
                    ...d
                }
            }

            if (d?.Forecast_Tab === 'Change Order') {
                coData[d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID] = { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
            }

            if (d?.Forecast_Tab === 'Day Zero Budget') {
                bData[d?.Forecast_Row_ID] = d
            }
        })

        //console.log('equipment uData', uData)

        Object.values(coData).forEach((row) => {
            if (row['52100'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['52100']) ? pNum(row['52100']) : 0)
            }

            if (row['Hours'] && row['Status'] === 'Approved' && (row['Forecast_Field_Name'] === 'totalEquipmentHours' ||
                (String(row['Cost_Type'] || '').trim() === '52100' && row['Forecast_Field_Name'] !== 'totalLaborHours'))) {
                totalCOHours = totalCOHours + (pNum(row['Hours']) ? pNum(row['Hours']) : 0)
            }
        })

        Object.values(bData).forEach((row) => {
            if (row['Value_Amount'] && row['Cost_Type'] == '52100') {
                dayZeroTotal = dayZeroTotal + (pNum(row['Value_Amount']) ? pNum(row['Value_Amount']) : 0)
            }

            if (row['Hours'] && row['Cost_Type'] == '52100') {
                dayZeroHoursTotal = dayZeroHoursTotal + (pNum(row['Hours']) ? pNum(row['Hours']) : 0)
            }
        })


        setTotalCOCost(fNum(totalCOCost,1))
        setTotalCOHours(fNum(totalCOHours,1))
        setTotalDayZero(fNum(dayZeroTotal,1))
        setTotalDayZeroHours(fNum(dayZeroHoursTotal,1))
        setCurrentBudget(fNum(totalCOCost + dayZeroTotal,1))
        setCurrentBudgetHours(fNum(totalCOHours + dayZeroHoursTotal,1))

        const equipmentBurn = []
        let totalHours = 0
        let totalCost = 0

        jobCostDetail?.forEach((row) => {
            if (row.Cost_Type_Code >= "52100" && row.Cost_Type_Code <= "52199") {
                equipmentBurn.push(row)
                totalHours = totalHours + row.Total_Hours
                totalCost = totalCost + row.Job_Cost
            }
        })

        setActualLaborHours(fNum(totalHours))
        setActualLaborCost(fNum(totalCost))
        //go through and group total amount by week from project starts to ends 
        let dateSections = {}
        let uniqueWeeks = {}
        let plannedStart;
        if (startDateActual) {
            plannedStart = moment(selectedJobData?.Planned_Start_Date).isBefore(startDateActual)
                ? moment(selectedJobData?.Planned_Start_Date)
                : moment(startDateActual);
        } else {
            plannedStart = moment(selectedJobData?.Planned_Start_Date);
        }
        const plannedFinish = moment(completionDateForecast ? completionDateForecast : selectedJobData?.Planned_Complete_Date)
        let currentDay = plannedStart
        let currentWeek = plannedStart.startOf('isoWeek')
        const days = plannedFinish.diff(plannedStart, 'days')
        for (let i = 0; i < days; i++) {
            const day = currentDay.clone()
            const week = currentDay.clone()
            day.add(i, 'days')
            week.add(i, 'days')
            currentWeek = week.startOf('isoWeek')
            const currentDayFormatted = day.format('YYYY-MM-DD')
            uniqueWeeks[currentWeek.format('YYYY-MM-DD')] = 1
            dateSections[currentDayFormatted] = [currentWeek.format('YYYY-MM-DD')]
        }

        const weeksEquipmentBurn = {}
        const weeksEquipmentBurnHours = {}
        const weeksEquipmentCount = {}
        equipmentBurn.forEach((row) => {
            const rowDate = moment(row.Consolidated_Date).add(12, 'hours').startOf('isoWeek')
            const rowDateFormatted = rowDate.format('YYYY-MM-DD')
            if (weeksEquipmentBurn[rowDateFormatted]) {
                weeksEquipmentBurn[rowDateFormatted] = weeksEquipmentBurn[rowDateFormatted] + row.Job_Cost
            } else {
                weeksEquipmentBurn[rowDateFormatted] = row.Job_Cost
            }

            if (weeksEquipmentBurnHours[rowDateFormatted]) {
                weeksEquipmentBurnHours[rowDateFormatted] = weeksEquipmentBurnHours[rowDateFormatted] + row.Total_Hours
            } else {
                weeksEquipmentBurnHours[rowDateFormatted] = row.Total_Hours
            }

            if (weeksEquipmentCount[rowDateFormatted] && !weeksEquipmentCount[rowDateFormatted][row.Unit_Number]) {
                weeksEquipmentCount[rowDateFormatted][row.Unit_Number] = 1
                weeksEquipmentCount[rowDateFormatted]['count'] = weeksEquipmentCount[rowDateFormatted]['count'] + 1
            } else if (!weeksEquipmentCount[rowDateFormatted]) {
                weeksEquipmentCount[rowDateFormatted] = {
                    [row.Unit_Number]: 1,
                    count: 1
                }
            }
        })
        // console.log('weeksEquipmentCount', weeksEquipmentCount)
        // console.log('weeksEquipmentBurn', weeksEquipmentBurn)
        // console.log('weeksEquipmentBurnHours', weeksEquipmentBurnHours)

        const equipmentBurnWeeks = []
        const equipmentEstWeeks = []
        let totalActualWeekHours = 0
        let totalActualWeekCost = 0
        let totalBurnPerHour = 0
        let totalHourPerWeek = 0
        let cummalitiveHours = 0
        let cummalativeHoursEst = 0
        let cummalitiveCostEst = 0
        Object.keys(uniqueWeeks).forEach((week, index) => {
            const future = !moment(week).isBefore(moment())
            totalActualWeekCost = totalActualWeekCost + (weeksEquipmentBurn[week] ? weeksEquipmentBurn[week] : 0)
            totalActualWeekHours = totalActualWeekHours + (weeksEquipmentBurnHours[week] ? weeksEquipmentBurnHours[week] : 0)
            cummalitiveHours = cummalitiveHours + (weeksEquipmentBurnHours[week] ? weeksEquipmentBurnHours[week] : 0)
            if (plannedFinish.isAfter(moment(week)) && moment(week).add(1, 'week').isAfter(moment(versionInfo?.Version_Start_DateTime))) {
                //cummalitiveHours = cummalitiveHours + (uData[week]?.hoursPerWeek ? pNum(uData[week]?.hoursPerWeek) : 0)
                cummalativeHoursEst = cummalativeHoursEst + ((uData[week]?.Number_Units && uData[week]?.Number_Hours ? pNum(uData[week]?.Number_Units) * pNum(uData[week]?.Number_Hours) : 0))
                cummalitiveCostEst = cummalitiveCostEst + ((uData[week]?.Rate && uData[week]?.Number_Units && uData[week]?.Number_Hours ? pNum(uData[week]?.Rate) * pNum(uData[week]?.Number_Units) * pNum(uData[week]?.Number_Hours) : 0))
                totalBurnPerHour = totalBurnPerHour + (uData[week]?.Rate ? uData[week]?.Rate : 0)
                totalHourPerWeek = totalHourPerWeek + (uData[week]?.Number_Hours ? uData[week]?.Number_Hours : 0)
            }
            equipmentBurnWeeks.push({
                id: index + 1,
                jobWeek: index + 1,
                week: week,
                highlight: !moment(week).isBefore(moment()),
                actualWeeklyHours: weeksEquipmentBurnHours[week] ? fNum(weeksEquipmentBurnHours[week],1) : 0,
                cummalitiveHours: fNum(cummalitiveHours,1),
                actualWeeklyCost: weeksEquipmentBurn[week] ? fNum(weeksEquipmentBurn[week],1) : 0,
                burnPerHour: 0,
                countEst: weeksEquipmentCount[week] ? weeksEquipmentCount[week].count : 0,
                backgroundColor: future ? '#e0e0e0' : 'white'
            })

            //console.log('calc values', uData[week])

            equipmentEstWeeks.push({
                id: index + 1,
                jobWeek: index + 1,
                week: week,
                highlight: !moment(week).isBefore(moment()),
                actualWeeklyHours: '',
                cummalitiveHours: fNum(cummalitiveHours + cummalativeHoursEst),
                actualWeeklyCost: '',
                burnPerHour: uData[week]?.Rate ? uData[week]?.Rate : 0,
                numOfWorkers: uData[week]?.Number_Units ? uData[week]?.Number_Units : 0,
                hoursPerWeek: uData[week]?.Number_Hours ? uData[week]?.Number_Hours : 0,
                notes: uData[week]?.Notes ? uData[week]?.Notes : '',
                countEst: 0,
                backgroundColor: future ? '#e0e0e0' : 'white'
            })
        })
        //console.log('est weeks', equipmentEstWeeks)
        setHistoricalWeeks(equipmentBurnWeeks)
        setEquipmentBurn(equipmentEstWeeks)
        setForecastLaborCost(fNum(cummalitiveCostEst,1))
        setForecastLaborHours(fNum(cummalativeHoursEst,1))
        setTotalCost(fNum(cummalitiveCostEst + totalCost,1))
        setTotalHours(fNum(cummalativeHoursEst + totalHours,1))
        setOverUnder(fNum(totalCOCost + dayZeroTotal - cummalitiveCostEst - totalCost,1))
        setOverUnderHours(fNum(totalCOHours + dayZeroHoursTotal - cummalativeHoursEst - totalHours,1))
        setPercentComplete((totalCOCost + dayZeroTotal) > 0 ? fNum((cummalitiveCostEst + totalCost) / (totalCOCost + dayZeroTotal) * 100,1) + '%' : '')
        setPercentCompleteHours((totalCOHours + dayZeroHoursTotal) ? fNum((cummalativeHoursEst + totalHours) / (totalCOHours + dayZeroHoursTotal) * 100,1) + '%' : '')
        setTotalActualCost(fNum(totalActualWeekCost,1))
        setTotalActualHours(fNum(totalActualWeekHours,1))
        setTotalEstCost(fNum(cummalitiveCostEst,1))
        setTotalEstHours(fNum(cummalativeHoursEst,1))
        setTotalBurnPerHour(fNum(totalBurnPerHour,1))
        setTotalHourPerWeek(fNum(totalHourPerWeek,1))
    }

    const HistoricalRow = ({ row }) => {
        const isHours = row.actualWeeklyHours && pNum(row.actualWeeklyHours) > 0 ? true : false
        const burnPerHour = pNum(row.actualWeeklyCost) / pNum(row.actualWeeklyHours)
        const isCurrentWeek = moment(row.week).add(1, 'week').isSame(moment(versionInfo?.Version_Start_DateTime), 'week')

        return (
            <View style={[s.container, { borderBottomWidth: isCurrentWeek ? 2 : 1, borderColor: isCurrentWeek ? '#0f172a' : '#e0e0e0' }]}>
                <Text style={s.spanHT}>
                    {row.jobWeek}
                </Text>
                <Text style={s.spanWeek}>
                    {row.week}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? row.actualWeeklyHours : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? row.cummalitiveHours : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? row.actualWeeklyCost : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? fNum(burnPerHour) : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? row.countEst : ''}
                </Text>
            </View>
        )
    }

    const EstimatedRow = ({ row }) => {
        const [burnPerHour, setBurnPerHour] = useState(row.burnPerHour)
        const [numOfWorkers, setNumOfWorkers] = useState(row.numOfWorkers)
        const [hoursPerWeek, setHoursPerWeek] = useState(row.hoursPerWeek)
        const [notes, setNotes] = useState(row.notes)
        const [estHours, setEstHours] = useState(0)
        const [estCost, setEstCost] = useState(0)
        const isInFuture = moment(row.week).add(1, 'week').isAfter(moment(versionInfo?.Version_Start_DateTime))
        const isCurrentWeek = moment(row.week).add(1, 'week').isSame(moment(versionInfo?.Version_Start_DateTime), 'week')
        const [localFocusedId, setLocalFocusedId] = useState(focusedId.current)
        const inputsRef = useRef([])
        const [textTimeout, setTextTimeout] = useState(null)
        const uniqueId = row.week


        useEffect(() => {
            if (focusedId.current == (uniqueId + '-burnPerHour')) {
                inputsRef.current[uniqueId + '-burnPerHour'].focus()
            } else if (focusedId.current == (uniqueId + '-numOfWorkers')) {
                inputsRef.current[uniqueId + '-numOfWorkers'].focus()
            } else if (focusedId.current == (uniqueId + '-hoursPerWeek')) {
                inputsRef.current[uniqueId + '-hoursPerWeek'].focus()
            } else if (focusedId.current == (uniqueId + '-notes')) {
                inputsRef.current[uniqueId + '-notes'].focus()
            }
        }, [localFocusedId])

        const updateLocalChanges = async (field, burnPerHour, numOfWorkers, hoursPerWeek, notes) => {
            if (selectedJob) {
                let data = {
                    active: 1,
                    userId: '154045',
                    userName: 'Seth Bailey',
                    fieldName: 'row',
                    tab: "Burn Tool Equipment",
                    rowId: row.week,
                    version: selectedVersion + '',
                    value: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    valueAmount: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    notes: notes,
                    projectStart: selectedJobData?.Planned_Start_Date,
                    projectFinish: completionDateForecast ? completionDateForecast : selectedJobData?.Planned_Complete_Date,
                    phaseStart: selectedJobData?.Phase_Start_Date,
                    phaseFinish: completionDateForecast ? completionDateForecast : selectedJobData?.Phase_Complete_Date,
                    rate: burnPerHour,
                    numberHours: hoursPerWeek,
                    numberUnits: numOfWorkers,
                    hours: numOfWorkers * hoursPerWeek,
                    active: 1,
                    id: selectedJob,
                    costType: '52100',
                    lockedVersion: lockedVersion
                }
                //console.log('saving data', data)
                updateUserDataArray(data)

                const stateUpdate = {
                    Forecast_Field_Name: field,
                    Forecast_Value: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    Value_Amount: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    Notes: notes,
                    Project_Start: selectedJobData?.Planned_Start_Date,
                    Project_Finish: completionDateForecast ? completionDateForecast : selectedJobData?.Planned_Complete_Date,
                    Phase_Start: selectedJobData?.Phase_Start_Date,
                    Phase_Finish: completionDateForecast ? completionDateForecast : selectedJobData?.Phase_Complete_Date,
                    Rate: burnPerHour,
                    Number_Hours: hoursPerWeek,
                    Number_Units: numOfWorkers,
                    Active: 1,
                    Forecast_Row_ID: row.week,
                    Forecast_Tab: "Burn Tool Equipment",
                    BU_ID: selectedJob,
                    Cost_Type: '52100',
                    key: row.week + '*' + field
                }

                let isRecorded = false
                let lChanges = {}
                
                localChanges.current.forEach((d) => {
                    // if (d.Forecast_Row_ID == row.week && d.Forecast_Field_Name == field && d.Forecast_Tab == "Burn Tool Equipment") {
                    //     isRecorded = true
                    //     d.Forecast_Value = pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour)
                    // }
                    // lChanges[d.Forecast_Row_ID + '*' + d.Forecast_Field_Name] = {...d, key: d.Forecast_Row_ID + '*' + d.Forecast_Field_Name}
                })

                // if (!isRecorded) {
                //     lChanges[row.week + '*' + field] = stateUpdate
                // }

                //console.log('local changes', lChanges, localChanges.current)
                localChanges.current = [...localChanges.current, stateUpdate]
            }
        }

        const updateState = () => {
            // let lChanges = {}
            // localChanges.current.forEach((d) => {
            //     lChanges[d.Forecast_Row_ID + '*' + d.Forecast_Field_Name] = {...d, key: d.Forecast_Row_ID + '*' + d.Forecast_Field_Name}
            // })
            // console.log('updating state', lChanges, localChanges.current)

            // const uData = JSON.parse(JSON.stringify(jobUserData))
            // uData.forEach((d) => {
            //     if (lChanges[d.Forecast_Row_ID + '*' + d.Forecast_Field_Name] && d.Forecast_Tab == "Burn Tool Equipment") {
            //         d.Forecast_Value = lChanges[d.Forecast_Row_ID + '*' + d.Forecast_Field_Name].Forecast_Value
            //         lChanges[d.Forecast_Row_ID + '*' + d.Forecast_Field_Name].updated = true
            //     }
            // })

            // const notUpdated = Object.values(lChanges).filter((d) => !lChanges[d.key].updated)
            // console.log('not updated', uData, notUpdated, localChanges.current, lChanges)

            let latestChanges = {};
            localChanges.current.forEach((d) => {
                latestChanges[d.Forecast_Row_ID] = d;
            });
            let notUpdated = Object.values(latestChanges);
            let uData = jobUserData ? jobUserData.filter(
                d => !latestChanges[d.Forecast_Row_ID]
            ) : [];
            setJobUserData([...uData, ...notUpdated])
        }

        useEffect(() => {
            setEstHours(fNum(pNum(numOfWorkers) * pNum(hoursPerWeek)))
            setEstCost(fNum(pNum(burnPerHour) * pNum(numOfWorkers) * pNum(hoursPerWeek)))

        }, [burnPerHour, numOfWorkers, hoursPerWeek])

        return (
            <View style={[s.container, { borderBottomWidth: isCurrentWeek ? 2 : 1, borderColor: isCurrentWeek ? '#0f172a' : '#e0e0e0' }]}>
                <Text style={s.spanHT}>
                    {row.jobWeek}
                </Text>
                <Text style={s.spanWeek}>
                    {row.week}
                </Text>
                <Text style={s.spanT}>
                    {estHours}
                </Text>
                {/* } */}
                <Text style={s.spanT}>
                    {isInFuture ? row.cummalitiveHours : ''}
                </Text>
                <Text style={s.spanT}>
                    {estCost}
                </Text>
                {isInFuture ? <TextInput style={s.tInput}
                    value={burnPerHour}
                    ref={e => {inputsRef.current[uniqueId + '-burnPerHour'] = e}}
                    onFocus={() => {focusedId.current = uniqueId + '-burnPerHour'}} 
                    onChangeText={t => {
                        setBurnPerHour(t)
                        clearTimeout(textTimeout)
                        updateLocalChanges('burnPerHour', t, numOfWorkers, hoursPerWeek, notes)
                        setLocalFocusedId(uniqueId + '-burnPerHour')
                        if (t.length > 0) {
                            setTextTimeout(setTimeout(() => {
                                updateState()
                            }, 1000))
                        }
                    }}
                    >
                </TextInput> : <Text style={s.spanT}>{burnPerHour}</Text>}
                {isInFuture ? <TextInput style={s.tInput}
                    value={numOfWorkers}
                    ref={e => {inputsRef.current[uniqueId + '-numOfWorkers'] = e}}
                    onFocus={() => {focusedId.current = uniqueId + '-numOfWorkers'}}  // Track the input when focused
                    onChangeText={t => {
                        setNumOfWorkers(t)
                        clearTimeout(textTimeout)
                        updateLocalChanges('numOfWorkers', burnPerHour, t, hoursPerWeek, notes)
                        setLocalFocusedId(uniqueId + '-numOfWorkers')
                        if (t.length > 0) {
                            setTextTimeout(setTimeout(() => {
                                updateState()
                            }, 1000))
                        }
                    }}>
                </TextInput> : <Text style={s.spanT}>{numOfWorkers}</Text>}
                {isInFuture ? <TextInput style={s.tInput}
                    value={hoursPerWeek}
                    ref={e => {inputsRef.current[uniqueId + '-hoursPerWeek'] = e}}
                    onFocus={() => {focusedId.current = uniqueId + '-hoursPerWeek'}}  // Track the input when focused
                    onChangeText={t => {
                        setHoursPerWeek(t)
                        clearTimeout(textTimeout)
                        updateLocalChanges('hoursPerWeek', burnPerHour, numOfWorkers, t, notes)
                        setLocalFocusedId(uniqueId + '-hoursPerWeek')
                        if (t.length > 0) {
                            setTextTimeout(setTimeout(() => {
                                updateState()
                            }, 1000))
                        }
                    }}>
                </TextInput> : <Text style={s.spanT}>{hoursPerWeek}</Text>}
                <Text style={s.spanT}>
                    {row.cummalativeHours ? fNum(pNum(row.cummalativeHours) * 100 / pNum(totalHours)) + '%' : ''}
                </Text>
                <TextInput style={s.tInputL}
                    ref={e => {inputsRef.current[uniqueId + '-notes'] = e}}
                    onFocus={() => {focusedId.current = uniqueId + '-notes'}}  // Track the input when focused
                    value={notes}
                    onChangeText={t => {
                        setNotes(t)
                        clearTimeout(textTimeout)
                        updateLocalChanges('notes', burnPerHour, numOfWorkers, hoursPerWeek, t)
                        setLocalFocusedId(uniqueId + '-notes')
                        if (t.length > 0) {
                            setTextTimeout(setTimeout(() => {
                                updateState()
                            }, 1000))
                        }
                    }}>
                </TextInput>
            </View>
        )
    }

    return (
        <View style={{ margin: 30, marginTop: 0 }}>
                {/* Subtab bar: Forecast Grid ↔ Equipment Dashboard */}
                {canSeeWipTabs && (
                <View style={{ flexDirection: 'row', gap: 4, marginBottom: 16, borderBottom: '1px solid #e2e8f0' }}>
                    {[{ key: 'grid', label: 'Forecast Grid' }, { key: 'dashboard', label: 'Equipment Dashboard' }].filter(t => !isPC || t.key === 'dashboard').map(t => (
                        <Pressable key={t.key} onPress={() => setSubTab(t.key)} style={{
                            paddingTop: 8, paddingBottom: 8, paddingLeft: 14, paddingRight: 14, cursor: 'pointer',
                            borderBottom: activeSubTab === t.key ? '2px solid #1d4ed8' : '2px solid transparent', marginBottom: -1,
                        }}>
                            <Text style={{ fontSize: 13, fontWeight: activeSubTab === t.key ? '700' : '500', color: activeSubTab === t.key ? '#1d4ed8' : '#64748b' }}>{t.label}</Text>
                        </Pressable>
                    ))}
                </View>
                )}
                {activeSubTab === 'dashboard' ? <EquipmentDashboard /> : <>
                {/* Equipment Rates Lookup Button */}
                <View style={{ marginBottom: 10, alignItems: 'flex-end' }}>
                    <Pressable
                        onPress={() => setShowRatesPopup(true)}
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#f8fafc',
                            padding: 10,
                            paddingHorizontal: 14,
                            borderRadius: 6,
                            flexDirection: 'row',
                            border: '1px solid #cbd5e1',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            cursor: 'pointer',
                        }}
                    >
                        <Text style={{ marginRight: 8, color: '#334155', fontWeight: '500', fontSize: 13 }}>Equipment Rates</Text>
                        <Text style={{ color: '#334155', fontSize: 14 }}>🔍</Text>
                    </Pressable>
                </View>

                {/* Equipment Rates Popup */}
                {showRatesPopup && (
                    <Pressable
                        onPress={() => setShowRatesPopup(false)}
                        style={{
                            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.3)',
                            zIndex: 1000,
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Pressable
                            onPress={(e) => e.stopPropagation()}
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: 10,
                                padding: 24,
                                width: 720,
                                maxHeight: '80vh',
                                boxShadow: '0 8px 30px rgba(0,0,0,0.18)',
                            }}
                        >
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                <Text style={{ fontSize: 16, fontWeight: '700', color: '#1e293b' }}>Equipment Rates Lookup</Text>
                                <Pressable onPress={() => setShowRatesPopup(false)} style={{ padding: 4, cursor: 'pointer' }}>
                                    <Text style={{ fontSize: 18, color: '#94a3b8', fontWeight: '700' }}>✕</Text>
                                </Pressable>
                            </View>
                            <TextInput
                                placeholder="Search tier or description..."
                                value={ratesSearch}
                                onChangeText={setRatesSearch}
                                style={{
                                    borderWidth: 1,
                                    borderColor: '#cbd5e1',
                                    borderRadius: 6,
                                    padding: 10,
                                    fontSize: 13,
                                    marginBottom: 12,
                                    outlineColor: '#2196f3',
                                }}
                            />
                            <View style={{ maxHeight: '60vh', overflow: 'auto' }}>
                                {/* Header */}
                                <View style={{ flexDirection: 'row', borderBottomWidth: 2, borderColor: '#e2e8f0', paddingBottom: 8, marginBottom: 4 }}>
                                    <Text style={{ flex: 2, fontSize: 12, fontWeight: '700', color: '#475569' }}>Equipment Tier</Text>
                                    <Text style={{ flex: 4, fontSize: 12, fontWeight: '700', color: '#475569' }}>Description</Text>
                                    <Text style={{ flex: 1, fontSize: 12, fontWeight: '700', color: '#475569', textAlign: 'right' }}>Hourly Rate</Text>
                                </View>
                                {/* Rows */}
                                {Object.entries(equipmentRates)
                                    .filter(([tier]) => {
                                        const q = ratesSearch.toLowerCase();
                                        const desc = (equipmentDescriptions[tier] || '').toLowerCase();
                                        return tier.toLowerCase().includes(q) || desc.includes(q);
                                    })
                                    .sort(([a], [b]) => a.localeCompare(b))
                                    .map(([tier, rate], i) => (
                                        <View key={tier} style={{
                                            flexDirection: 'row',
                                            paddingVertical: 6,
                                            paddingHorizontal: 4,
                                            backgroundColor: i % 2 === 0 ? '#f8fafc' : '#fff',
                                            borderRadius: 4,
                                        }}>
                                            <Text style={{ flex: 2, fontSize: 12, color: '#334155' }}>{tier}</Text>
                                            <Text style={{ flex: 4, fontSize: 12, color: '#475569' }}>{equipmentDescriptions[tier] || '-'}</Text>
                                            <Text style={{ flex: 1, fontSize: 12, color: '#334155', textAlign: 'right', fontWeight: '600' }}>
                                                {rate ? '$' + parseFloat(rate).toFixed(2) : '-'}
                                            </Text>
                                        </View>
                                    ))}
                                {Object.entries(equipmentRates)
                                    .filter(([tier]) => {
                                        const q = ratesSearch.toLowerCase();
                                        const desc = (equipmentDescriptions[tier] || '').toLowerCase();
                                        return tier.toLowerCase().includes(q) || desc.includes(q);
                                    }).length === 0 && (
                                    <Text style={{ padding: 16, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
                                        {Object.keys(equipmentRates).length === 0 ? 'No equipment rates loaded' : 'No matching equipment tiers'}
                                    </Text>
                                )}
                            </View>
                        </Pressable>
                    </Pressable>
                )}

                <View style={{ flexDirection: 'row', marginTop: 20 }}>
                    <View style={{ alignItems: 'flex-end' }}>
                        <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                            <View style={s.container}>
                                <View style={s.span2H}>
                                </View>
                                <Text style={s.spanH}>
                                    Budget
                                </Text>
                                <Text style={s.spanH}>
                                    CO Log
                                </Text>
                                <Text style={s.spanH}>
                                    Current Budget
                                </Text>
                                <Text style={s.spanH}>
                                    Actuals
                                </Text>
                                <Text style={s.spanH}>
                                    Projected
                                </Text>
                                <Text style={s.spanH}>
                                    Total
                                </Text>
                                <Text style={s.spanH}>
                                    (Over)/Under
                                </Text>
                                <Text style={s.spanH}>
                                    % Comp
                                </Text>
                            </View>
                            <View style={s.container}>
                                <Text style={s.span2H}>
                                    Total Equipment Hours
                                </Text>
                                <Text style={s.spanT}>
                                    {totalDayZeroHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalCOHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {currentBudgetHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {actualLaborHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {forecastLaborHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {overUnderHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {percentCompleteHours}
                                </Text>
                            </View>
                            <View style={s.container}>
                                <Text style={s.span2H}>
                                    Total Equipment Cost
                                </Text>
                                <Text style={s.spanT}>
                                    {totalDayZero}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalCOCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {currentBudget}
                                </Text>
                                <Text style={s.spanT}>
                                    {actualLaborCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {forecastLaborCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {overUnder}
                                </Text>
                                <Text style={s.spanT}>
                                    {percentComplete}
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={{ flexDirection: 'row', marginTop: 20, marginBottom: 100 }}>
                    <View style={{ alignItems: 'flex-start', marginRight: 20 }}>
                        <Text style={s.sectionTitle}>Historical Weeks on Job #{selectedJob}</Text>
                        <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.08, shadowRadius: 4, elevation: 2 }}>
                            <View style={[s.container, { position: 'sticky', backgroundColor: '#f1f5f9', top: 0, zIndex: 10 }]}>
                                <Text style={s.spanHH}>
                                    Job Week
                                </Text>
                                <Text style={s.spanWeekH}>
                                    Week (starting Monday)
                                </Text>
                                <Text style={s.spanH}>
                                    Act. Weekly Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Cumulative Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Act. Weekly Cost
                                </Text>
                                <Text style={s.spanH}>
                                    Burn per hour
                                </Text>
                                <Text style={s.spanH}>
                                    Equipment Count
                                </Text>
                            </View>
                            {historicalWeeks.map((row, index) => (
                                <HistoricalRow key={index} row={row} />))
                            }
                            <View style={s.container}>
                                <Text style={s.spanHTotals}>
                                </Text>
                                <Text style={s.spanWeekTotals}>
                                    Totals
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalActualHours}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalActualCost}
                                </Text>
                                <Text style={s.spanTotals}>
                                    {fNum(pNum(totalActualCost) / pNum(totalActualHours))}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                            </View>
                        </View>
                    </View>
                    <View style={{ alignItems: 'flex-start' }}>
                        <Text style={s.sectionTitle}>Estimated Weeks on Job #{selectedJob}</Text>
                        <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.08, shadowRadius: 4, elevation: 2 }}>
                            <View style={[s.container, { position: 'sticky', backgroundColor: '#f1f5f9', top: 0, zIndex: 10 }]}>
                                <Text style={s.spanHH}>
                                    Job Week
                                </Text>
                                <Text style={s.spanWeekH}>
                                    Week (starting Monday)
                                </Text>
                                <Text style={s.spanH}>
                                    Weekly Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Cumulative Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Weekly Cost
                                </Text>
                                <Text style={s.spanH}>
                                    Burn per hour
                                </Text>
                                <Text style={s.spanH}>
                                    # of Pieces
                                </Text>
                                <Text style={s.spanH}>
                                    # of Hours per week
                                </Text>
                                <Text style={s.spanH}>
                                    % Complete
                                </Text>
                                <Text style={s.span3H}>
                                    Weekly Events / Schedule / Milestones / Explanation of Manpower
                                </Text>
                            </View>
                            {equipmentBurn.map((row, index) => (
                                <EstimatedRow key={index} row={row} />
                            ))}
                            <View style={s.container}>
                                <Text style={s.spanHTotals}>
                                </Text>
                                <Text style={s.spanWeekTotals}>
                                    Totals
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalEstHours}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalEstCost}
                                </Text>
                                <Text style={s.spanTotals}>
                                    {fNum(totalBurnPerHour)}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                                <Text style={s.spanTotals}>
                                    {fNum(totalHourPerWeek)}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                                <Text style={s.span3Totals}>
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
                </>}
            <AuditHistoryPanel tabKey="equipment" />
        </View>
    );
};

export default BurnToolEquipment;


